import { on } from 'delegated-events';

const $forms = document.querySelectorAll('form.donation-form__form');
const $repeatDonationCheckBox = document.querySelector('input[name="RepeatDonation"]');
const $repeatDonationInput = document.querySelector('.dropdown__repeat-donation');
// const $donationCheckToggle = document.querySelector('.donation-check-toggle');
const $donationCheckContent = document.querySelector('.donation-check-content');
const fn = {
    init: () => {
        on('change', 'input[name="RepeatDonation"]', () => {
            let isChecked = $repeatDonationCheckBox.checked;
            if (isChecked) {
                $($repeatDonationInput).addClass('active');
            } else {
                $($repeatDonationInput).removeClass('active');
            }
            return false;
        });
        on('click', '.donation-check-toggle', e => {
            e.preventDefault();
            if ($($donationCheckContent).hasClass('active')) {
                $($donationCheckContent).removeClass('active');
            } else {
                $($donationCheckContent).addClass('active');
            }
            return false;
        });
    },
};

export default {
    can: () => $forms.length,
    run: fn.init,
};
